<template>
  <Callout.Root variant="warning" @close="emit('close')">
    We had some trouble parsing this document.
  </Callout.Root>
</template>

<script setup lang="ts">
import Callout from "@/design_system/Callout";

const emit = defineEmits<{
  switch: [];
  close: [];
}>();
</script>
